<div
  *ngIf="isVisible"
  class="relative z-50"
  aria-labelledby="report-export-modal-title"
  role="dialog"
  aria-modal="true"
>
  <!-- Background backdrop -->
  <div class="fixed inset-0 bg-secondary-900 bg-opacity-50 backdrop-blur-sm transition-opacity" (click)="onCancel()"></div>

  <!-- Modal container -->
  <div class="fixed inset-0 z-10 w-screen overflow-y-auto" (click)="onCancel()">
    <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <div
        class="px-6 pt-6 pb-6 relative transform overflow-hidden rounded-2xl bg-white dark:bg-secondary-800 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md"
        (click)="$event.stopPropagation()"
      >
        <!-- Close button -->
        <div class="absolute right-0 top-0 pr-4 pt-4">
          <button
            type="button"
            (click)="onCancel()"
            class="rounded-md bg-transparent text-gray-400 hover:text-gray-500 focus:outline-none"
          >
            <span class="sr-only">Close</span>
            <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <!-- Modal content -->
        <div class="text-center">
          <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-blue-600/10 mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="h-6 w-6 text-blue-600">
              <path d="M10.75 2.75a.75.75 0 0 0-1.5 0v8.614L6.295 8.235a.75.75 0 1 0-1.09 1.03l4.25 4.5a.75.75 0 0 0 1.09 0l4.25-4.5a.75.75 0 0 0-1.09-1.03l-2.955 3.129V2.75Z" />
              <path d="M3.5 12.75a.75.75 0 0 0-1.5 0v2.5A2.75 2.75 0 0 0 4.75 18h10.5A2.75 2.75 0 0 0 18 15.25v-2.5a.75.75 0 0 0-1.5 0v2.5c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25v-2.5Z" />
            </svg>
          </div>

          <h3 id="report-export-modal-title" class="text-lg font-semibold text-gray-900 dark:text-white mb-2">
            Confirm Export
          </h3>

          <!-- Selected reports -->
          <p *ngIf="selectedCount > 0" class="text-sm text-gray-500 dark:text-primary-200 mb-2">
            You are about to export
            <span class="font-semibold text-gray-900 dark:text-white">{{ selectedCount | number:'1.0-0' }}</span>
            selected {{ selectedCount === 1 ? 'report' : 'reports' }}.
          </p>

          <!-- No selection: fall back to filter-based export -->
          <p *ngIf="selectedCount === 0" class="text-sm text-gray-500 dark:text-primary-200 mb-2">
            No reports are selected. This will export
            <span class="font-semibold text-gray-900 dark:text-white">all reports</span>
            matching your current filters.
          </p>

          <p class="text-sm text-gray-500 dark:text-primary-200 mb-6">
            This queues an export job. You'll be notified when the file is ready to download.
          </p>

          <div class="flex gap-3">
            <button
              type="button"
              (click)="onCancel()"
              [disabled]="exporting"
              class="flex-1 rounded-lg border border-gray-300 dark:border-[#3b4377] bg-white dark:bg-transparent px-4 py-2.5 text-sm font-medium text-gray-700 dark:text-primary-200 hover:bg-gray-50 dark:hover:bg-secondary-900 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Cancel
            </button>
            <button
              type="button"
              (click)="onConfirm()"
              [disabled]="exporting"
              class="flex-1 inline-flex items-center justify-center rounded-lg bg-blue-600 px-4 py-2.5 text-sm font-medium text-white hover:bg-blue-700 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <svg *ngIf="exporting" class="animate-spin h-4 w-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              {{ exporting ? 'Exporting...' : 'Export' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
